import type { GetAllInput } from "@types_def/common/filter.types";
import type Driver from "@types_def/models/driver.types";

import { sendRequest } from "../../clients/axios";

export function downloadDrivers(filters: GetAllInput<Driver, "id">) {
  sendRequest<GetAllInput<Driver, "id">, { data: Iterable<number> }>(
    "post",
    "drivers/downloadXlsx",
    filters
  )
    .then((res) => {
      if (res.status === 201) {
        const bufferParsed = new Uint8Array(res.data.data);
        const blob = new Blob([bufferParsed], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        return URL.createObjectURL(blob);
      }
    })
    .then((fileURL) => {
      const windowReference = window.open("", "_self");
      // @ts-expect-error
      if (windowReference) {
        windowReference.location = fileURL;
      }
    });
}
